// extracted by mini-css-extract-plugin
export default {"main":"Balakovskii_main__oGZ-c","cover":"Balakovskii_cover__ws75x","flex_col":"Balakovskii_flex_col__s-Azz"};